import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailArrowInIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M9 9V9.5C9 10.3284 9.67157 11 10.5 11C11.1215 11 11.6547 10.6221 11.8823 10.0835C11.9581 9.90412 12 9.70695 12 9.5V9C12 8.4774 11.9198 7.97352 11.7711 7.5M9 9C9 10.0998 8.10611 10.9922 7.00626 10.995C5.90113 10.9977 5 10.1026 5 8.9975C5 7.89431 5.89556 7 6.99875 7C8.10332 7 9 7.89543 9 9ZM9.5 13.3311C8.76457 13.7565 7.91072 14 7 14C4.23858 14 2 11.7614 2 9C2 6.23858 4.23858 4 7 4C7.5226 4 8.02648 4.08018 8.5 4.2289" }), /* @__PURE__ */ _jsx("path", { d: "M10.75 5.25V1.75M10.75 5.25H14.25M10.75 5.25L14.25 1.75" })]
});
export default SvgEmailArrowInIcon;
